export { Link } from './templates/link';
export { Redirect } from './templates/redirect';
export { Route } from './templates/route';
export { Switch } from './templates/switch';

export { init } from './init';
export { commisRouteUpdateAction } from './action';




// WEBPACK FOOTER //
// ./src/index.js